import type { NextPage } from "next";
import { Homepage } from "../containers/screens/Homepage";

const Home: NextPage = () => {
  return <Homepage />;
};

export default Home;
